module.exports = __webpack_public_path__ + "static/media/success-icon.19878abc.svg";